import React, { useState } from "react";
import {
  closePopup,
  getPopupRegistration,
  openPopup,
  Priority
} from "app/PopupHolder";
import Modal from "components/base/Modal";
import css from "../style.scss";
import classNames from "classnames";
import { formatToLongDate } from "../../../utils/date/formatDate";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTeamMember ,selectUserId } from "data/user/selectors";
import { RemoveTeamMemberAPI } from "data/user/actions";
import { getTeamMembers } from "data/user/actions";
import { getFullDataURL } from "../Team/validationSchemas";
import userImg from 'assets/images/account-page/user-icon-lg.png';
import LeaveMessagePopup from "./LeaveMessage";

const RemoveTeamMemberPopup = (props) => {

  const dispatch = useDispatch();
  const teamMemberDetails = useSelector(selectSelectedTeamMember).toJS();
  const userId = useSelector(selectUserId)

  const [imageUrl, setImageUrl] = useState(teamMemberDetails?.profilePicture || null);

  const handleClose = () => {
    props.closePopup();
  };

  const handleConfirmChanges = async () => {
    console.log("Remove Team Member");
    const req = { 
        userId: userId, // Current user ID
        teamMemberId : teamMemberDetails?.userId
    }
    // Enable after API works
    try {
      const response = await RemoveTeamMemberAPI(req); // Await the async function
      if (response.success) {
        console.log("successful:", response.teamMember);
        dispatch(getTeamMembers(userId))
        props.closePopup();
      } else {
        console.error("failed:", response.error);
        dispatch(LeaveMessagePopup.open({
          title: "Error",
          message: response.error,
          yesLable: "Ok",
          cancelLable: null,
          CancelRedirect: () => null,
          yesRedirect: () => null
        }))
      }
    } catch (error) {
      console.error("Unexpected error:", error);
      dispatch(LeaveMessagePopup.open({
        title: "Error",
        message: response.error,
        yesLable: "Ok",
        cancelLable: null,
        CancelRedirect: () => null,
        yesRedirect: () => null
      }))
    }
  };

  return (
    <Modal
      modalClassName={css.pricingModal}
      className={classNames(css.clsAccPageModals, css.clsBillingModal)}
      isOpen
      uniqId="RemoveTeamMemberPopup"
      width="auto"
      padding="0px 0px 0px"
      onClose={handleClose}
    >
      <div className={classNames(css.modal_lg, "modal-dialog m-0")}>
        <div className={classNames(css.clsModalContent, "modal-content w-100")}>
          <div className={classNames(css.clsModalContentBody, "modal-body rounded")}>
            <div className={css.clsModalHeader}>
              <h2 className={css.clsModalTitle}>Remove Team Member?</h2>
            </div>

            <div className={classNames(css.clsModalBody)}>
              <div className={classNames(css.clsModalBodyInner, "clearfix w-100")}>
                <h3 className={classNames(css.clsNameSubTitle,)}>
                  {teamMemberDetails?.fullName}
                </h3>
                <h5 className={classNames(css.clsModalSubTitle, css.clsReloadSubTitle, 'pt-0')}>
                 {teamMemberDetails?.userType === 'SCOUT' ? 'Scout' : 'Full Access'}
                </h5>
                <div className={classNames(css.clsGreyCircle)}>
                {/* <div className={css.clstProfileImg}> */}
                  {imageUrl ? (
                      <img src={getFullDataURL(imageUrl)} alt="Profile" className={classNames(css.profileImage)}/>
                  ) : (
                      <img src={userImg} alt="Profile" />
                  )}
              {/* </div> */}
                </div>
              </div>

              <div className={classNames("clearfix w-100")}>
                <h5 className={classNames(css.clsModalSubTitle, css.clsReloadSubTitle,)}>
                  You are about to Delete this Team Member.
                </h5>
                
                {teamMemberDetails?.userType === 'SCOUT' ? (
                  <h5 className={classNames(css.clsModalSubTitle, css.clsReloadSubTitle,)}>
                  You will have access to the Team Member until your next billing cycle, on {formatToLongDate(teamMemberDetails?.billDate)}.
                  </h5>
                ) : (
                  <h5 className={classNames(css.clsModalSubTitle, css.clsReloadSubTitle,)}>
                  You will have access to the Team Member <span>and Full Access Team Member slot</span> until your next billing cycle, on {formatToLongDate(teamMemberDetails?.billDate)}.
                </h5>
                )}
              </div>
            </div>

            <div className={classNames(css.clsModalFooter)}>
              <button className={classNames(css.btn_lg, css.btn_primary, css.text_primary,)} onClick={handleClose}> Cancel</button>
              <button className={classNames(css.btn_lg, css.clsBtnOrng)} onClick={handleConfirmChanges}>  Confirm </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

const registrationId = getPopupRegistration(RemoveTeamMemberPopup);
RemoveTeamMemberPopup.open = (props = {}) =>
  openPopup(registrationId, { ...props, priority: Priority.MEDIUM });
RemoveTeamMemberPopup.close = () => closePopup({ popup: registrationId });

export default RemoveTeamMemberPopup;
